import { InstrumentsUrl, ClockUrl } from '@icons';
import { delimiter, useHHMMCounter } from '@features/components/CaseCard/Blocks/Timeline/util';
import { useEffect, useState } from 'react';
import { isNil } from 'lodash-es';
import { TimeLineItem } from './TimeLineItem';
import { TimeLine } from '../../types';
import { MS_IN_S } from '@/constants/date.constants';

type CardTimelineProps = {
  color: string;
  operationTimeline: TimeLine;
  showCounter?: boolean;
};

export const CardTimeline = ({ color, operationTimeline, showCounter = false }: CardTimelineProps) => {
  const { xcTime, pfStart, ocsPt, pfEnd } = operationTimeline ?? {};
  const [hours, minutes]: string[] = useHHMMCounter(showCounter, ocsPt);
  const [showDelimiter, setShowDelimiter] = useState(true);

  useEffect(() => {
    if (!showCounter) {
      setShowDelimiter(true);
      return;
    }

    const intervalColon = setInterval(() => {
      setShowDelimiter((prev: boolean) => !prev);
    }, MS_IN_S / 2);

    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(intervalColon);
    };
  }, [showCounter]);

  return (
    <div className="flex w-full gap-3">
      <TimeLineItem color={color} image={InstrumentsUrl} label="XC time" value={xcTime} withLineRight />
      <TimeLineItem color={color} image={ClockUrl} label="PF Start" value={pfStart} withLineRight />
      <div
        className={`flex flex-1 flex-col items-center justify-center gap-0.5 rounded h-10 min-w-[55px] px-1 mt-2 ${ocsPt ? 'bg-white' : 'bg-base-40 opacity-60'}`}
      >
        <div className="text-s-m">OCS PT</div>
        {!isNil(hours) && !isNil(minutes) ? (
          <div className="text-s-sb">
            <span>{hours}</span>
            <span className="min-w-[4px] inline-block text-center">{showDelimiter ? delimiter : ''}</span>
            <span>{minutes}</span>
          </div>
        ) : (
          <div className="text-s-sb">--:--</div>
        )}
      </div>
      <TimeLineItem color={color} image={ClockUrl} label="PF End" value={pfEnd} withLineLeft />
    </div>
  );
};
